import { Button } from '@lana-ui/login';
import '../../Statics/Scss/Features/Layout/RightContentHeader.scss';
import { readCookie } from '../../Helpers/Cookies';
import Link from '../Common/common/src/link/Link';
import Logout from '../../Handlers/_Logout';

const RightContentHeader = () => {
    const email = readCookie('usuarioemail');

    const handleOnClickLogout = () => {
        Logout.Logout(true);
    }

    return (
        <div className="contenedor-rightContentHeader row-gap row-gap-desksm-2">
            <Link className="--font-bold --twoxs" href={`${process.env.REACT_APP_MYACCOUNT}mi-usuario`}>
                {email}
            </Link>
            <Button tag="input" label="Cambiar de cuenta" className="--border-blue" onClick={handleOnClickLogout} />
        </div>
    );
};

export default RightContentHeader;
